module.exports = __webpack_public_path__ + "static/apple-icon-57x57-772511822d87ed21266be5264d2cae14.png";